import React from 'react';
import type { IconComponent } from './icons';
interface MedallionProps {
  icon: IconComponent;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 bg-parchment ${className}`} aria-hidden="true" data-id="element-139" data-mp="1zc0pfxs6ab1n">
      <Icon className="h-6 w-6 text-gold" strokeWidth={1.4} data-id="element-140" data-mp="28d8d7lx2bthh" />
    </span>;
}